import { getPositioningParent } from "../helpers/get-positioning-parent.js";
/**
 * @public
 */
export function hasPositioningParent(device, predicate) {
    return (element) => getPositioningParent(element, device).some(predicate);
}
//# sourceMappingURL=has-positioning-parent.js.map